// extracted by mini-css-extract-plugin
export default {"Table":"load_Table__YUo8E"};